import { isDefined } from "@clipboard-health/util-ts";
import { Alert, type AlertColor } from "@mui/material";
import { type CustomContentProps, useSnackbar } from "notistack";
import { forwardRef, type ReactNode } from "react";

interface SnackbarToastProps extends CustomContentProps {
  onClick?: () => void;
  icon?: ReactNode;
}

export const SnackbarToast = forwardRef<HTMLDivElement, SnackbarToastProps>((props, ref) => {
  const { id, message, variant, style, icon, onClick } = props;
  const alertSeverity: AlertColor = variant === "default" ? "info" : variant;
  const { closeSnackbar } = useSnackbar();
  return (
    <Alert
      ref={ref}
      style={style}
      id={String(id)}
      severity={alertSeverity}
      variant="filled"
      icon={icon}
      sx={{
        minWidth: {
          xs: "initial",
          md: 600,
        },
        fontWeight: (theme) => theme.typography.fontWeightRegular,
        cursor: isDefined(onClick) ? "pointer" : "default",
      }}
      onClose={() => {
        closeSnackbar(id);
      }}
      onClick={onClick}
    >
      {message}
    </Alert>
  );
});

SnackbarToast.displayName = "SnackbarToast";
